<template>
  <v-container grid-list-xl fluid>
    <DimensionSelector v-on:room="setRoom($event)" :valueName="item.name" :valueWidth="item.width" :valueDrop="item.drop" ref="dimensionSelector" @ready="isReady => readyToSubmitDimension = isReady" :type="this.item.type"></DimensionSelector>

    <template>
      <!-- Brand -->
      <div v-if="$v.item.variations.brand.$error" class="red--text">Please select Brand</div>
      <v-autocomplete v-model="selectedBrand" :items="brands" item-value="_id" label="Brand" :filter="filterBrandAndRange">
        <template slot="selection" slot-scope="data">
          {{ data.item.name }}
        </template>
        <template slot="item" slot-scope="data">
          <v-list-tile-content>
            <v-list-tile-title v-html="`${data.item.name}`"></v-list-tile-title>
          </v-list-tile-content>
        </template>
      </v-autocomplete>
      <div class="v-card__actions">
        <v-spacer></v-spacer>
        <v-btn small flat color="primary" @click="onClickingAddBrand()">Add Brand</v-btn>
      </div>

      <!-- Range -->
      <div v-if="$v.item.variations.range.$error" class="red--text">Please select Range</div>
      <v-autocomplete v-model="item.variations.range" :items="ranges" item-value="_id" label="Range" :filter="filterBrandAndRange">
        <template slot="selection" slot-scope="data">
          {{ data.item.name }}
        </template>
        <template slot="item" slot-scope="data">
          <v-list-tile-content>
            <v-list-tile-title v-html="`${data.item.name}`"></v-list-tile-title>
          </v-list-tile-content>
        </template>
      </v-autocomplete>
      <div class="v-card__actions">
        <v-spacer></v-spacer>
        <v-btn small flat color="primary" @click="onClickingAddRange()">Add Range</v-btn>
      </div>

      <div v-if="$v.item.variations.fabricPricePerMeter.$error" class="red--text">Please enter Fabric Price Per Meter</div>
      <v-text-field @change="getFabricSize()" class="disableField" label="Fabric Price Per Meter" :disabled="true" v-model="item.variations.fabricPricePerMeter"></v-text-field>

      <div v-if="$v.item.variations.fabricRollWidth.$error" class="red--text">Please enter Fabric Roll Width</div>
      <v-text-field @change="getFabricSize()" class="disableField" label="Fabric Roll Width" :disabled="true" v-model="item.variations.fabricRollWidth"></v-text-field>

      <div v-if="$v.item.variations.fabricColorLabel.$error" class="red--text">Please enter Fabric - Colour Label</div>
      <v-text-field label="Fabric - Colour Label" v-model="item.variations.fabricColorLabel"></v-text-field>
    </template>

    <CustomizationSelector title="Control Side" :value="item.variations.controlSide" :options="['Left', 'Right']" v-on:selected-option="item.variations.controlSide = $event" :v="$v.item.variations.controlSide" :error="$v.item.variations.controlSide.$error"></CustomizationSelector>

    <CustomizationSelector title="Drive Type" :value="item.variations.driveType" :options="['Cord and Cleat', 'Chain Drive']" v-on:selected-option="item.variations.driveType = $event" :v="$v.item.variations.driveType" :error="$v.item.variations.driveType.$error"></CustomizationSelector>

    <div v-if="item.variations.driveType == 'Cord and Cleat'">
      <CustomizationSelector title="Cleat Type" :value="item.variations.cordCleatType" :options="['Clear', 'Chrome', 'Brass']" v-on:selected-option="item.variations.cordCleatType = $event" :v="$v.item.variations.cordCleatType" :error="$v.item.variations.cordCleatType.$error"></CustomizationSelector>
    </div>

    <div v-if="incInstall">
      <v-checkbox label="Install?" color="primary" v-model="customInstall"></v-checkbox>
      <v-text-field v-if="customInstall" label="Install Price" v-model="item.installPrice"></v-text-field>
    </div>

    <!-- Margin -->
    <div v-if="$v.item.variations.margin.$error" class="red--text">Please enter Margin</div>
    <v-text-field label="Margin" v-model="item.variations.margin" append-icon="%"></v-text-field>

    <!-- <v-checkbox label="Motorized?" color="primary" v-model="motorized"></v-checkbox>
    <v-select v-if="motorized" @change="motorActions" v-model="item.motor" :items="[{ text: 'SOMFY - Sonesse 30 Li-ion'},{ text: 'SOMFY - Altus 28 Li-ion'},{ text: 'SOMFY - Altus 40 RTS - wired'},{ text: 'SOMFY - Sonesse 40 30/30 - wired'},{ text: 'ACMEDA - AUTOMATE | Li-ion 1.1'}, { text: 'ACMEDA - AUTOMATE | Li-ion 3.0'}, { text: 'ACMEDA - AUTOMATE | E6 - wired'}]" label="Motor"></v-select>
    <v-text-field v-if="motorized" label="Motor Price" v-model="item.motorPrice" readonly></v-text-field> -->
    <v-textarea name="notes" label="Line Item Notes" v-model="item.notes"></v-textarea>
    <v-btn v-if="!edit" @click="addItem()" color="primary">Add {{ item.type }}</v-btn>
    <v-btn v-else @click="addItem()" color="primary">Update {{ item.type }}</v-btn>
    <b>${{ (item.total).toFixed(2) }}</b>
    <div class="mt-4 ml-2">
      <p><b>Fabric Price:</b> {{fabricPrice}}</p>
      <p><b>Make Price:</b> {{makePrice}}</p>
      <p><b>Chain Drive Price:</b> {{chainDrivePrice}}</p>
      <p><b>GST:</b> 10% </p>
    </div>

    <!-- Add new Brand popup for custom curtain -->
    <v-dialog v-model="addBrandDialoug" max-width="600px">
      <v-card>
        <v-card-title>Add New Brand</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <div v-if="$v.brandNameText.$error" class="red--text">Please Enter Brand</div>
          <v-text-field v-model="brandNameText" label="Add Brand"></v-text-field>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="primary" flat @click="addBrandDialoug = false">Close</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="onClickingSavedBrand()">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Add new Range popup for custom curtain -->
    <v-dialog v-model="addRangeDialoug" max-width="600px">
      <v-card>
        <v-card-title>Add New Range</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <div v-if="$v.selectedBrandFromRangePopup.$error" class="red--text">Please Select Brand</div>
          <v-autocomplete v-model="selectedBrandFromRangePopup" :items="brands" item-value="_id" label="Select Brand" :filter="filterBrandAndRange">
            <template slot="selection" slot-scope="data">
              {{ data.item.name }}
            </template>
            <template slot="item" slot-scope="data">
              <v-list-tile-content>
                <v-list-tile-title v-html="`${data.item.name}`"></v-list-tile-title>
              </v-list-tile-content>
            </template>
          </v-autocomplete>
          <div v-if="$v.rangeNameText.$error" class="red--text">Please Enter Range</div>
          <v-text-field v-model="rangeNameText" label="Add Range"></v-text-field>

          <div v-if="$v.priceText.$error" class="red--text">Please Enter Price</div>
          <v-text-field v-model="priceText" label="Add Price"></v-text-field>

          <div v-if="$v.widthText.$error" class="red--text">Please Enter Width</div>
          <v-text-field v-model="widthText" label="Add Width"></v-text-field>

          <h4>Sheer</h4>
          <div v-if="$v.sheerOption.$error" class="red--text">Please Select Sheer Option</div>
          <v-radio-group v-model="sheerOption" row>
            <v-radio label="Yes" color="primary" value="true"></v-radio>
            <v-radio label="No" color="primary" value="false"></v-radio>
          </v-radio-group>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="primary" flat @click="addRangeDialoug = false">Close</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="onClickingSavedRange()">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ItemService from '@/services/ItemService'
import CurtainService from '@/services/CurtainService'
import FabricRangeSelector from '@/components/parts/FabricRangeSelector'
import FabricSelector from '@/components/parts/FabricSelector'
import ColorSelector from '@/components/parts/ColorSelector'
import CustomizationSelector from '@/components/parts/CustomizationSelector'
import DimensionSelector from '@/components/parts/DimensionSelector'
import { required, requiredIf } from 'vuelidate/lib/validators'

const gConfig = require('../../../gConfig.json')

export default {
  props: {
    edittingItem: {
      default: null
    },
    editChange: {
      default: null
    }
  },
  components: {
    FabricRangeSelector,
    FabricSelector,
    ColorSelector,
    CustomizationSelector,
    DimensionSelector
  },
  data () {
    return {
      fabricPrice: 0,
      makePrice: 0,
      chainDrivePrice: 0,
      selectedBrand: null,
      brands: [],
      ranges: [],
      addBrandDialoug: false,
      addRangeDialoug: false,
      brandNameText: null,
      rangeNameText: null,
      selectedBrandFromRangePopup: null,
      priceText: null,
      widthText: null,
      sheerOption: null,
      readyToSubmitDimension: false,
      customInstall: false,
      motorized: false,
      edit: false,
      item: {
        type: 'Soft Roman Blind',
        fabric: null,
        color: null,
        name: null,
        width: null,
        drop: null,
        total: 0,
        orderID: null,
        installPrice: 0,
        motor: null,
        motorPrice: 0,
        notes: null,
        variations: {
          brand: null,
          range: null,
          fabricPricePerMeter: null,
          fabricRollWidth: null,
          fabricColorLabel: null,
          margin: 70,
          controlSide: null,
          driveType: null,
          cordCleatType: null
        }
      },
      incInstall: gConfig.install
    }
  },
  validations: {
    item: {
      // fabric: { required },
      // color: { required },
      name: { required },
      drop: { required },
      width: { required },
      variations: {
        brand: { required },
        range: { required },
        fabricPricePerMeter: { required },
        fabricRollWidth: { required },
        fabricColorLabel: { required },
        margin: { required },
        controlSide: { required },
        driveType: { required },
        cordCleatType: { required: requiredIf(function () { return this.item.variations.driveType === 'Cord and Cleat' }) }
      }
    },
    brandNameText: { required: requiredIf(function () { return this.addBrandDialoug === true }) },
    selectedBrandFromRangePopup: { required: requiredIf(function () { return this.addRangeDialoug === true }) },
    rangeNameText: { required: requiredIf(function () { return this.addRangeDialoug === true }) },
    priceText: { required: requiredIf(function () { return this.addRangeDialoug === true }) },
    widthText: { required: requiredIf(function () { return this.addRangeDialoug === true }) },
    sheerOption: { required: requiredIf(function () { return this.addRangeDialoug === true }) }
  },
  mounted () {
    this.getBrands()
    this.useEdittingItem(this.edittingItem)
  },
  watch: {
    'item.variations.range': {
      handler (range) {
        for (var rangeObj of this.ranges) {
          if (rangeObj._id === range) {
            this.item.variations.fabricPricePerMeter = rangeObj.price
            this.item.variations.fabricRollWidth = rangeObj.width
            this.getFabricSize()
          }
        }
      },
      deep: true
    },
    selectedBrand: function (val) {
      this.item.variations.brand = val
      this.getRanges(val)
    },
    item: {
      handler (item) {
        this.getPrice(item)
      },
      deep: true
    },
    motorized (val) {
      if (!val) {
        this.item.motor = null
        this.item.motorPrice = 0
      }
    },
    customInstall (val) {
      if (!val) {
        this.item.installPrice = 0
      }
    },
    edittingItem (item) {
      this.useEdittingItem(item)
    }
  },
  methods: {
    resetBrandFields () {
      this.$v.brandNameText.$reset()
      this.brandNameText = null
    },
    onClickingAddBrand () {
      this.resetBrandFields()
      this.addBrandDialoug = true
    },
    async getRanges (brand) {
      const response = await CurtainService.getRanges(brand)
      this.ranges = response.data.ranges
    },
    async getBrands () {
      const response = await CurtainService.getBrands()
      this.brands = response.data.brands
    },
    filterBrandAndRange (item, queryText, itemText) {
      var name = item.name.toLowerCase()
      if (name) {
        const searchText = queryText.toLowerCase()
        return name.indexOf(searchText) > -1
      } else {
        return false
      }
    },
    async onClickingSavedBrand () {
      this.$v.brandNameText.$touch()
      if (this.$v.brandNameText.$pending || this.$v.brandNameText.$error) {
        return false
      }
      const response = await CurtainService.addNewBrand({
        name: this.brandNameText
      })
      if (response.data.success) {
        this.brands = response.data.brands
        this.addBrandDialoug = false
      }
    },
    async onClickingSavedRange () {
      this.$v.selectedBrandFromRangePopup.$touch()
      this.$v.rangeNameText.$touch()
      this.$v.priceText.$touch()
      this.$v.widthText.$touch()
      this.$v.sheerOption.$touch()
      if (this.$v.selectedBrandFromRangePopup.$pending || this.$v.selectedBrandFromRangePopup.$error || this.$v.rangeNameText.$pending || this.$v.rangeNameText.$error || this.$v.priceText.$pending || this.$v.priceText.$error || this.$v.widthText.$pending || this.$v.widthText.$error || this.$v.sheerOption.$pending || this.$v.sheerOption.$error) {
        return false
      }
      const response = await CurtainService.addNewRange({
        name: this.rangeNameText,
        brand: this.selectedBrandFromRangePopup,
        price: this.priceText,
        width: this.widthText,
        sheer: this.sheerOption
      })
      if (response.data.success) {
        this.addRangeDialoug = false
        if (this.item.variations.brand) {
          this.getRanges(this.item.variations.brand)
        }
      }
    },
    onClickingAddRange () {
      this.resetRangeFields()
      this.addRangeDialoug = true
    },
    resetRangeFields () {
      this.$v.selectedBrandFromRangePopup.$reset()
      this.$v.rangeNameText.$reset()
      this.$v.priceText.$reset()
      this.$v.widthText.$reset()
      this.$v.sheerOption.$reset()
      this.rangeNameText = null
      this.selectedBrandFromRangePopup = null
      this.priceText = null
      this.widthText = null
      this.sheerOption = null
    },
    async getFabricSize () {
      // console.log(new Date())
      if (this.item.width <= 0) {
        return
      }
      // this.item.variations.fabricPricePerMeter
      this.fabricRollWidthUsable = this.item.variations.fabricRollWidth - 90
      // this.getFabricPrice(this.fabricSize, multiplier, this.item.variations.range)
    },
    async getPrice (item) {
      const response = await ItemService.getPricing(item)
      if (response.data.price) {
        this.item.total = response.data.price
      }
      this.fabricPrice = 0
      this.makePrice = 0
      this.chainDrivePrice = 0
      if (response.data.fabricPrice) {
        this.fabricPrice = response.data.fabricPrice
      }
      if (response.data.makePrice) {
        this.makePrice = response.data.makePrice
      }
      if (response.data.chainDrivePrice) {
        this.chainDrivePrice = response.data.chainDrivePrice
      }
    },

    setRoom (room) {
      this.item.width = room.width
      this.item.drop = room.drop
      this.item.name = room.name
    },

    addItem () {
      this.$refs.dimensionSelector.touch()
      this.$v.item.$touch()
      if (this.$v.item.$pending || this.$v.item.$error || !this.readyToSubmitDimension) return

      this.edit = false
      this.$emit('create-item', this.item)
    },

    async motorActions (value) {
      switch (value) {
        case 'SOMFY - Sonesse 30 Li-ion':
          this.item.motorPrice = 295
          break
        case 'SOMFY - Altus 28 Li-ion':
          this.item.motorPrice = 210
          break
        case 'SOMFY - Altus 40 RTS - wired':
          this.item.motorPrice = 265
          break
        case 'SOMFY - Sonesse 40 30/30 - wired':
          this.item.motorPrice = 380
          break
        case 'ACMEDA - AUTOMATE | Li-ion 1.1':
          this.item.motorPrice = 250
          break
        case 'ACMEDA - AUTOMATE | Li-ion 3.0':
          this.item.motorPrice = 350
          break
        case 'ACMEDA - AUTOMATE | E6 - wired':
          this.item.motorPrice = 199
          break
      }
    },

    useEdittingItem (item) {
      if (!this.editChange) {
        if (item) {
          this.edit = true
          this.item = item
          this.motorized = parseInt(item.motorPrice) > 0
          this.customInstall = parseInt(item.installPrice) > 0
          if (item.variations.brand) {
            this.selectedBrand = item.variations.brand._id
            this.item.variations.brand = item.variations.brand._id
          }
          if (item.variations.range) {
            this.item.variations.range = item.variations.range._id
          }
        }
      } else {
        this.item = {
          type: 'Soft Roman Blind',
          fabric: null,
          color: null,
          name: null,
          width: null,
          drop: null,
          total: 0,
          orderID: null,
          installPrice: 0,
          motor: null,
          motorPrice: 0,
          notes: null,
          variations: {
            brand: null,
            range: null,
            fabricPricePerMeter: null,
            fabricRollWidth: null,
            fabricColorLabel: null,
            margin: 70,
            controlSide: null,
            driveType: null,
            cordCleatType: null
          }
        }
        this.item._id = item._id
        this.item.name = item.name
        this.item.width = item.width
        this.item.drop = item.drop
        this.item.orderID = item.orderID
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/products/SoftRomanBlind.vue